import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import SearchSVG from '../../assets/images/icons/search.svg';
import EditSVG from '../../assets/images/icons/edit.svg';

/*
    - api
*/
import addPassengerAPI from '../../api/add/Passenger';

const Toolbar = ({ props, alertProps, nationalCodeSearchProps, reloadPassengerProps }) => {

    /*
       - default data
    */
    const [nations, setNations] = React.useState([]);
    const [addPassengerParameters, setAddPassengerParameters] = React.useState({
        firstName: {
            value: '',
            color: 'dark'
        },
        lastName: {
            value: '',
            color: 'dark'
        },
        nationalCode: {
            value: '',
            color: 'dark'
        },
        nationId: {
            value: '',
            color: 'dark'
        },
        nationality: false
    });
    const [activeTab, setActiveTab] = React.useState(['bg-gray-light', 'bg-white']);
    const [placeholder, setPlaceholder] = React.useState('به فارسی');
    const [nationalCodeSearchKey, setNationalCodeSearchKey] = React.useState('');

    React.useEffect(() => {
        if (props.nations.status === 200) {
            setNations(props.nations.data);
        }
    }, [props]);

    /*
        - addPassengerHandler
    */
    const addPassengerHandler = (key, value) => {
        if (addPassengerParameters.nationality === false) {
            if (key === 'firstName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'danger'
                    }
                });
            } else if (key === 'firstName') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'dark'
                    }
                });
            }
            if (key === 'lastName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'danger'
                    }
                });
            } else if (key === 'lastName') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'dark'
                    }
                });
            }
            if (key === 'nationalCode') {
                if ((value.length === 0 || value.length === 10) && /^[0-9,۰-۹]+$/.test(value)) {
                    setAddPassengerParameters({
                        ...addPassengerParameters,
                        nationalCode: {
                            value: value,
                            color: 'dark'
                        }
                    });
                } else {
                    setAddPassengerParameters({
                        ...addPassengerParameters,
                        nationalCode: {
                            value: value,
                            color: 'danger'
                        }
                    });
                }
            }
        } else {
            if (key === 'firstName' && (value === '' || !/^[a-zA-Z ]+$/.test(value))) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'danger'
                    }
                });
            } else if (key === 'firstName') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    firstName: {
                        value: value,
                        color: 'dark'
                    }
                });
            }
            if (key === 'lastName' && (value === '' || !/^[a-zA-Z ]+$/.test(value))) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'danger'
                    }
                });
            } else if (key === 'lastName') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    lastName: {
                        value: value,
                        color: 'dark'
                    }
                });
            }
            if (key === 'nationalCode') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    nationalCode: {
                        value: value,
                        color: 'dark'
                    }
                });
            }
            if (key === 'nationId' && value !== '') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    nationId: {
                        value: value,
                        color: 'dark'
                    }
                });
            } else if (key === 'nationId') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    nationId: {
                        value: value,
                        color: 'danger'
                    }
                });
            }
        }
    }

    /*
        - addPassenger
    */
    const addPassenger = async () => {
        let parameters = {};
        let isValid = 1;
        if (addPassengerParameters.nationality === false) {
            if (addPassengerParameters.firstName.value === '' || !/^[آ-ی ]+$/.test(addPassengerParameters.firstName.value)) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    firstName: {
                        value: addPassengerParameters.firstName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (addPassengerParameters.lastName.value === '' || !/^[آ-ی ]+$/.test(addPassengerParameters.lastName.value)) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    lastName: {
                        value: addPassengerParameters.lastName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (!(addPassengerParameters.nationalCode.value.length === 10 && /^[0-9,۰-۹]+$/.test(addPassengerParameters.nationalCode.value))) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    nationalCode: {
                        value: addPassengerParameters.nationalCode.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
        } else {
            if (addPassengerParameters.firstName.value === '' || !/^[a-zA-Z ]+$/.test(addPassengerParameters.firstName.value)) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    firstName: {
                        value: addPassengerParameters.firstName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (addPassengerParameters.lastName.value === '' || !/^[a-zA-Z ]+$/.test(addPassengerParameters.lastName.value)) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    lastName: {
                        value: addPassengerParameters.lastName.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (addPassengerParameters.nationalCode.value.length === 0) {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    nationalCode: {
                        value: addPassengerParameters.nationalCode.value,
                        color: 'danger'
                    }
                });
                isValid = 0;
            }
            if (addPassengerParameters.nationId.value === '') {
                setAddPassengerParameters({
                    ...addPassengerParameters,
                    nationId: {
                        value: addPassengerParameters.nationId.value,
                        color: 'danger',
                    }
                });
                isValid = 0;
            }
        }
        if (isValid === 1) {
            parameters.Name = addPassengerParameters.firstName.value;
            parameters.Family = addPassengerParameters.lastName.value;
            parameters.NationalCode = addPassengerParameters.nationalCode.value;
            parameters.NationId = addPassengerParameters.nationId.value;
            parameters.Nationality = addPassengerParameters.nationality;
            let result = await addPassengerAPI(parameters);
            if (result === 'success') {
                setAddPassengerParameters({
                    firstName: {
                        value: '',
                        color: 'dark'
                    },
                    lastName: {
                        value: '',
                        color: 'dark'
                    },
                    nationalCode: {
                        value: '',
                        color: 'dark'
                    },
                    nationId: {
                        value: '',
                        color: 'dark'
                    },
                    nationality: false
                });
                toggleTab(false);
                closeModal('addPassengerModal');
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadPassengerProps(Math.floor(Math.random() * 100));
            } else {
                closeModal('addPassengerModal');
                alertProps(['danger', 'خطایی رخ داده است']);
            }
        }
    }

    /*
        - nationalCodeSearch
    */
    const nationalCodeSearch = () => {
        nationalCodeSearchProps(nationalCodeSearchKey);
    }

    /*
        - toggleTab
    */
    const toggleTab = (nationality) => {
        if (nationality === false) {
            setActiveTab(['bg-gray-light', 'bg-white']);
            setPlaceholder('به فارسی');
            setAddPassengerParameters({
                ...addPassengerParameters,
                nationality: false
            });
        }
        if (nationality === true) {
            setActiveTab(['bg-white', 'bg-gray-light']);
            setPlaceholder('به انگلیسی');
            setAddPassengerParameters({
                ...addPassengerParameters,
                nationality: true
            });
        }
        setAddPassengerParameters({
            firstName: {
                value: '',
                color: 'dark'
            },
            lastName: {
                value: '',
                color: 'dark'
            },
            nationalCode: {
                value: '',
                color: 'dark'
            },
            nationId: {
                value: '',
                color: 'dark'
            },
            nationality: nationality
        });
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <Typography
                            component='h4'
                            ms={{
                                fontWeight: 'normal !important'
                            }}>
                            لیست مهمانان
                        </Typography>
                        <Typography
                            className={`d-block`}
                            component='p'
                            ms={{
                                color: '#6F6F7E'
                            }}>
                            می توانید لیست مهمانان خود را در زیر اضافه کنید، تااز خدمات ایران هتل آنلاین بهره‌مند شوند.
                        </Typography>
                    </Grid.Item>
                    <Grid.Item
                        className={`position-relative`}
                        size='col-8 md-4'>
                        <TextField
                            onChange={(value) => setNationalCodeSearchKey(value)}
                            placeholder='جستجو بر اساس کدملی یا پاسپورت'
                            value={nationalCodeSearchKey} />
                        <Button
                            onClick={nationalCodeSearch}
                            variant='light'
                            color='primary'
                            size='sm'
                            ms={{
                                position: 'absolute',
                                top: '12px',
                                left: '12px',
                            }}>
                            <Image
                                src={SearchSVG} />
                        </Button>
                    </Grid.Item>
                    <Grid.Item
                        className={`text-left`}
                        size='col-4 md-8'>
                        {(scale === 'xx-large' || scale === 'x-large' || scale === 'large' || scale === 'medium' || scale === 'small') &&
                            <Button
                                onClick={() => openModal('addPassengerModal')}
                                color='primary'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                افزودن مهمان جدید
                            </Button>
                        }
                        {(scale === 'x-small' || scale === 'x-small') &&
                            <Button
                                onClick={() => openModal('addPassengerModal')}
                                color='primary'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                مهمان جدید
                            </Button>
                        }
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
            <Modal
                className={`addPassengerModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    <Modal.Header
                        className={`border-solid-bottom border-light`}>
                        افزودن مهمان جدید
                        <Box />
                    </Modal.Header>
                    <Box
                        className={`my-md mt-0`} />
                    <Typography
                        className={`px-lg`}>
                        اطلاعات همراه و یا مهمان خود را اضافه نمایید.
                    </Typography>
                    <Box
                        className={`p-sm`}
                        component='form'>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item
                                    size='col-12'>
                                    <Box
                                        className={`d-flex justify-content-center`}>
                                        <Typography
                                            onClick={() => toggleTab(false)}
                                            className={`p-sm ${activeTab[0]} rounded-sm pointer`}>
                                            مهمان ایرانی
                                        </Typography>
                                        <Box
                                            className={`mx-sm`} />
                                        <Typography
                                            onClick={() => toggleTab(true)}
                                            className={`p-sm ${activeTab[1]} rounded-sm pointer`}>
                                            مهمان خارجی
                                        </Typography>
                                    </Box>
                                    <Box
                                        className={`my-md mb-0 divider-horizontal divider-light`} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12'>
                                    <TextField
                                        onChange={(value) => addPassengerHandler('firstName', value)}
                                        color={addPassengerParameters.firstName.color}
                                        label='نام *'
                                        icon={EditSVG}
                                        placeholder={placeholder}
                                        value={addPassengerParameters.firstName.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12'>
                                    <TextField
                                        onChange={(value) => addPassengerHandler('lastName', value)}
                                        color={addPassengerParameters.lastName.color}
                                        label='نام خانوادگی *'
                                        icon={EditSVG}
                                        placeholder={placeholder}
                                        value={addPassengerParameters.lastName.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12'>
                                    <TextField
                                        onChange={(value) => addPassengerHandler('nationalCode', value)}
                                        color={addPassengerParameters.nationalCode.color}
                                        label='کد ملی (شماره پاسپورت) *'
                                        icon={EditSVG}
                                        value={addPassengerParameters.nationalCode.value} />
                                </Grid.Item>
                                {addPassengerParameters.nationality === true &&
                                    <Grid.Item
                                        size='col-12'>
                                        <Select
                                            onChange={(value) => addPassengerHandler('nationId', value)}
                                            label='ملیت *'
                                            color={addPassengerParameters.nationId.color}
                                            value={addPassengerParameters.nationId.value}
                                            init={45}
                                            search>
                                            {nations.map((obj, index) => {
                                                return (
                                                    <Select.Item
                                                        key={index}
                                                        value={obj.id}>
                                                        {obj.nationTitle}
                                                    </Select.Item>
                                                )
                                            })}
                                        </Select>
                                    </Grid.Item>
                                }
                                <Grid.Item
                                    className={`d-flex pb-0`}
                                    size='col-12 md-6'>
                                    <Button
                                        className={`w-25`}
                                        onClick={addPassenger}
                                        variant='filled'
                                        color='primary'>
                                        تایید
                                    </Button>
                                    <Box
                                        className={`d-inline-block mx-sm`} />
                                    <Button
                                        className={`w-25`}
                                        onClick={() => closeModal('addPassengerModal')}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );

}

export default Toolbar;